import { z } from 'zod';
/** `Error` identifies an evaluation failure, while `Failed` identifies unexpected flow behavior. */
export const FlowTestResultSchema = z.enum(['Passed', 'Failed', 'Error']);
export const FlowTestResult = FlowTestResultSchema.enum;
//# sourceMappingURL=result.js.map